import { ListItem, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
const draggingStyles = css `
  &:active:not(:disabled, [disabled]) {
    position: relative;
    z-index: 1;
    box-shadow: ${themeGet('dropShadow.100')};
    border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
    background: ${themeGet('colors.background.50')};
  }
`;
export const ColumnItemContainer = styled(ListItem) `
  margin: 0 ${themeGet('spacing.sm')};
  width: calc(100% - ${themeGet('spacing.sm')} * 2);
  cursor: default;
  ${draggingStyles}
`;
export const HiddenItemContainer = styled(ListItem) `
  margin: 0 ${themeGet('spacing.sm')};
  width: calc(100% - ${themeGet('spacing.sm')} * 2);
`;
